import { useNavigate } from 'react-router-dom';
import OnboardingForm from './OnboardingForm';
import { safeLocalStorage } from '../lib/safeStorage';

interface OnboardingFlowProps {
  mode?: 'landing' | 'start';
}

export default function OnboardingFlow({ mode = 'start' }: OnboardingFlowProps) {
  const navigate = useNavigate();

  function handleSessionCreated(result: {
    sessionId: string;
    partnerAToken: string;
    partnerBToken: string;
    partnerBShareUrl: string;
  }) {
    safeLocalStorage.setItem(`quiz_token_${result.sessionId}`, result.partnerAToken);
    safeLocalStorage.setItem(`quiz_token_b_${result.sessionId}`, result.partnerBToken);

    navigate(`/share/${result.sessionId}`);
  }

  const isLanding = mode === 'landing';

  return (
    <div className={isLanding ? '' : 'max-w-lg mx-auto'}>
      {!isLanding && (
        <div className="text-center mb-6">
          <h2 className="text-2xl font-bold text-white mb-2">
            Let&apos;s get started
          </h2>
        </div>
      )}

      <OnboardingForm
        layout={isLanding ? 'split' : 'stacked'}
        onSessionCreated={handleSessionCreated}
      />
    </div>
  );
}
